/* Suresh Peddavoora 10/26/2022 3075154998  Added outlined icons and  Class Name for Table
Suresh Peddavoora 10/28/2022 3075154998  Added Rows per screen text in  Table pagination  */

/*
akhila 10/28/2022 3075154998  Modified payload in search Api for sorting
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Dilip 11/03/2022 3075154998 Added record code in delete popup
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
// import { ErrorSnackbar, SuccessSnackbar } from "../../../../components/CustomSnackBar";
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {fetchDmRecord} from '../../../../../redux/reducers/EnableFramework/DmRecords';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
export default function FilterSearchTable({
  setTabValue,
  searchData,
  setFilterCode,
  setFilterCodeName,
  submit,
  setSubmit,
  setIsCopyRowData,
  setUsageState,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isLoading,
  setDeleteUsage,
  setFieldRowData,
  fieldRowData,
  isUsage,
  setIsUsage,
}) {
  const [message, setMessage] = useState('');
  const columns = [
    {
      title: 'Record Code',
      field: 'recordCode',
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
    },
    {
      title: 'Field Separator',
      field: 'fieldSeparator',
    },
    {
      title: 'Filter Code',
      field: 'filterCode',
    },
    {
      title: 'Filter GroupCode',
      field: 'filterGroupCode',
    },
    {
      title: 'Fixed Length',
      field: 'fixedLength',
    },
    {
      title: 'Master Record',
      field: 'masterRecord',
    },
    {
      title: 'Post Match Filter',
      field: 'postMatchFilter',
    },
    {
      title: 'Post Match Filter Group',
      field: 'postMatchFilterGroup',
    },
  ];
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteData, setDeleteData] = useState({});
  const [status, setStatus] = useState(false);
  const tableRef = createRef();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setUsageState(false);
  // }, []);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  // useEffect(() => {
  //   setIsCopyRowData(false);
  // }, []);
  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);
  const handleDelete = (rowData) => {
    // setDeleteRowInfo(rowData);
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`dmrecord/delete/record/${deleteData?.recordCode}`).then((response) => {
      if (response?.status === 200) {
        setIsDelete(false);
        setStatus(true);
        setMessage(response?.response);
        setTimeout(() => {
          setMessage('');
        }, 3000);
      }
    });
  };

  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // const handleDeleteUsage = () => {
  //   if (userMetrixDelete) {
  //     setFieldRowData(deleteRowInfo);
  //     setValueCode(2);
  //   } else {
  //     handleSubmit();
  //   }
  // };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete DM Record"
        value={`Are you sure you want to delete this ${deleteData?.recordCode} Dm Record?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12}>
        <div className="custom-table custom-actions-icon custom-toolbar-icons global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `dmrecord/findall/records`;
                const bodyObj = {
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  fieldSeparator: '',
                  filterCode: '',
                  filterGroupCode: '',
                  fixedLength: 'Y',
                  masterRecord: '',
                  postMatchFilter: '',
                  postMatchFilterGroup: '',
                  recordCode: '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this filter?'}},
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      // disabled={dataCount === 0}
                    >
                      Add Records
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
              {
                icon: () => (
                  <>
                    <DeleteOutlineOutlinedIcon />
                  </>
                ),
                tooltip: 'Delete',
                onClick: (event, rowData) => {
                  handleDelete(rowData);
                },
              },
            ]}
            onRowClick={(event, rowData) => {
              // setFilterCode(rowData?.id);
              // setFilterCodeName(rowData?.name);
              setTabValue(1);
              dispatch(fetchDmRecord(rowData?.recordCode));
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
